module.exports = function(app) {
	app.run(['Service', '$q','sessionData', function (Service, $q, sessionData) {
		return new Service({

			name: 'enrollments',
			group: 'eprsvc',
			url: '/eprsvc/x-services/secure/enrollments/:subscriberSSN',
			cache: false,

			fetch: function() {
                if(sessionData && sessionData.clientNumber && sessionData.clientNumber !== undefined){
                    this.headers['ClientNumber']  = sessionData.clientNumber;
                }
				return this.get();
			},
            fetchPathSSN: function(ssn) {
                if(sessionData && sessionData.clientNumber && sessionData.clientNumber !== undefined){
                    this.headers['ClientNumber']  = sessionData.clientNumber;
                }
                                   this.url = '/eprsvc/x-services/secure/enrollments/subscriberSSN';
                                   return this.post(ssn);
                               },

			save: function(data, umi) {
                if(sessionData && sessionData.clientNumber && sessionData.clientNumber !== undefined){
                    this.headers['ClientNumber']  = sessionData.clientNumber;
                }
				return this.put({ payload: data });
			},
			 delSSN: function(data) {
				 this.url = '/eprsvc/x-services/secure/enrollments/subscriberSSN';
				 return this.del(data);
			},

			check: function(ssn, forcedToFail) {
				if (forcedToFail === 'genericFailure') { return $q.reject(new Error('forcedToFail')); }
				if (forcedToFail === 'pendingTransaction') { return $q.when(true); }

				return this.fetch().then(
					function(response) {
						if (
							response &&
							response.data &&
							response.data.payload &&
							Array.isArray(response.data.payload.enrollmentsInProgress)
						) {
							return response.data.payload.enrollmentsInProgress.some(
								function(e) { return e.ssn == ssn && e.status !== 'SAVED'; }
							);
						}
						else {
							return true; // if we can't determine otherwise, we need to assume there's one in progress
						}
					},
					function(error) {
						if (
							error.data &&
							error.data.baseMessage &&
							error.data.baseMessage.returnCode == 100231
						) {
							return false; // this should be an empty array and not an error, but here we are
						}
						else {
							return $q.reject(error);
						}
					}
				);
			}
		});
	}]);


	app.run(['Service','sessionData', function (Service,sessionData) {
		return new Service({

			name: 'enrollmentsPrefixesAndRelationships',
			group: 'eprsvc',
			url: '/eprsvc/x-services/secure/enrollments/prefix-and-relationship-values',
			cache: true,

			fetch: function() {
                if(sessionData && sessionData.clientNumber && sessionData.clientNumber !== undefined){
                    this.headers['ClientNumber']  = sessionData.clientNumber;
                }
				return this.get().then(
					function(response) {
						if (response && response.data && response.data.payload) {
							return response.data.payload;
						}
					}
				);
			}
		});
	}]);
	app.run(['Service','sessionData', function (Service,sessionData) {
		return new Service({

			name: 'enrollmentsSpecialStatusValues',
			group: 'eprsvc',
			url: '/eprsvc/x-services/secure/enrollments/special-status-values',
			cache: true,

			fetch: function() {
                if(sessionData && sessionData.clientNumber && sessionData.clientNumber !== undefined){
                    this.headers['ClientNumber']  = sessionData.clientNumber;
                }
				return this.get().then(
					function(response) {
						if (response && response.data && response.data.payload) {
							return response.data.payload;
						}
					}
				);
			}
		});
	}]);
};
